/**
 * useContainerWidth
 * Tracks the width of a referenced element via ResizeObserver.
 * Used by the AI Workspace to apply container-based responsive styles
 * (since the workspace lives inside a flexible chat panel and global
 * media queries on the viewport don't reflect its real width).
 */
import { useEffect, useRef, useState } from 'react';

const useContainerWidth = () => {
  const ref = useRef(null);
  const [width, setWidth] = useState(0);

  useEffect(() => {
    const el = ref.current;
    if (!el) return;

    setWidth(el.offsetWidth);

    const observer = new ResizeObserver((entries) => {
      for (const entry of entries) {
        const next = entry.contentRect?.width ?? entry.target.offsetWidth;
        setWidth(Math.round(next));
      }
    });
    observer.observe(el);
    return () => observer.disconnect();
  }, []);

  return [ref, width];
};

export default useContainerWidth;
